export default '0.6000834441968981'